import { z } from "zod";
import { daysOptions } from "./common";

// Define the base work schedule schema type

// Personal Information Schema
export const personalInfoSchema = z.object({
  firstName: z
    .string()
    .nonempty("First name is required")
    .min(2, "First name must be at least 2 characters long"),
  lastName: z
    .string()
    .nonempty("Last name is required")
    .min(2, "Last name must be at least 2 characters long"),
  phone: z
    .string()
    .nonempty("Phone number is required")
    .regex(/^(?:\+|0)\d{1,4}[\d-]{1,20}$/, "Invalid phone number format"),
  address: z.string().nonempty("Address is required"),
  locality: z
    .string()
    .nonempty("City is required")
    .min(2, "City must be at least 2 characters long"),
  postalCode: z
    .string()
    .nonempty("Postal code is required")
    .min(4, "Postal code must be at least 4 characters long"),
  country: z.string().nonempty("Country is required"),
  state: z.string().optional(),
});

export const workScheduleSchema = z.object({
  workdays: z
    .array(z.string())
    .min(1, "At least one working day is required. You can change it later.")
    .refine(
      (days) =>
        days.every((day) => daysOptions.some((option) => option.value === day)),
      "Invalid workday value",
    ),
  startWorkTime: z.string().nonempty("Start work time is required"),
  endWorkTime: z.string().nonempty("End work time is required"),
});

// Export types derived from schemas
export type PersonalInfoFormValues = z.infer<typeof personalInfoSchema>;
export type WorkScheduleFormValues = z.infer<typeof workScheduleSchema>;
